export default __webpack_public_path__ + "static/media/logo1.a5158c56.png";